import React from 'react';

import RootFooter from './root/RootFooter';
import RootHeader from './root/RootHeader';
import PageProviders from './page/PageProviders';
import type { PageLayoutProps } from './page/pageConfig';
import type { HeaderProps } from '../../src/entities/header';

export type { PageLayoutProps } from './page/pageConfig';

export default function PageLayout({
  children,
  pageProps = {},
  skipChrome = false,
}: React.PropsWithChildren<PageLayoutProps & { skipChrome?: boolean }>) {
  const headerProps: HeaderProps = pageProps?.headerProps ?? {};

  return (
    <>
      {!skipChrome ? <RootHeader headerProps={headerProps} /> : null}
      <PageProviders pageConfig={pageProps}>{children}</PageProviders>
      {!skipChrome ? <RootFooter pageProps={pageProps} /> : null}
    </>
  );
}
